import { z } from "zod";

export const DischargeLetterCardiologyFormSchema = z.object({
  additional_diagnostic_findings: z.string().optional(),
  admission_medications: z.string().optional(),
  allergies: z.string().optional(),
  anamnesis: z.string().optional(),
  appointments: z.string().optional(),
  diagnoses: z.string().optional(),
  discharge_medications: z.string().optional(),
  ecg: z.string().optional(),
  findings: z.string().optional(),
  lab_results: z.string().optional(),
  laboratory_parameters: z.string().optional(),
  physical_status: z.string().optional(),
  recommendations: z.string().optional(),
  social_history: z.string().optional(),
  therapy_and_course: z.string().optional(),
});
